import './css/Loading.css';

import React, { useState, useEffect } from 'react';

const Loading = () => {

    return (
        <div id='loading'>
            <div id="square1"></div>
            <div id="square2"></div>
            <div id="square3"></div>
            <div id="square4"></div>
            <div id="square5"></div>
        </div>
    );
};

export default Loading;
